<div class="modulo-sobre about">
      <h3 class="title-h3">{{data.titulo}}</h3>
      <article [innerHtml]="data.params.texto" class="p-margin"></article>  
      <div class="content-button">
            <button type="button" (click)="toAbout()"> 
                  <span>{{'Ver Mais' | translate}}</span>
            </button>    
      </div>
</div>